import api from './api';

/**
 * Send secure email for a single study.
 */
export const sendSecureEmail = async (data) => {
  const response = await api.post('/messages/send', data);
  return response.data;
};

/**
 * Send the same secure email for multiple studies at once (max 10).
 * @param {Object} data - { studyIds[], recipientEmail, note, sendImage, sendReport, anonymize, ... }
 */
export const sendBulkSecureEmail = async (data) => {
  const response = await api.post('/messages/send-bulk', data);
  return response.data;
};

/**
 * Get message history
 */
export const getMessageHistory = async (params = {}) => {
  const response = await api.get('/messages/history', { params });
  return response.data;
};

/**
 * Get specific message by ID
 */
export const getMessageById = async (messageId) => {
  const response = await api.get(`/messages/history/${messageId}`);
  return response.data;
};


export const revokeExternalShare = async shareId => {
  await api.delete(`/secure-viewer/shares/${shareId}`);
};
